<script setup lang="ts">
type AvailableMarkType = 'free' | 'new'

type Props = {
  type?: AvailableMarkType
}
defineProps<Props>()
</script>

<template>
  <div
    v-if="type"
    class="tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-xs tw-px-2 tw-py-1 tw-text-2xs tw-font-bold tw-uppercase tw-text-white"
    :class="{
      'tw-bg-[var(--color-cute)]': type === 'free',
      'tw-bg-[var(--color-param)]': type === 'new',
    }"
  >
    <span>{{ $t(`influencer.textBadge.${type}`) }}</span>
  </div>
</template>
